import axios from 'axios';
import config from '../../../config';

const state = {
  tipologie: [],
  annoRinnovo: '',
  param: '',
};

const getters = {
  getTipologie: () => state.tipologie,
  getSezioni: () => state.tipologie.filter((t) => t.Tipo === 'Sezione'),
  getCategorieEvento: () => state.tipologie.filter((t) => t.Tipo === 'TipoCategoria' && t.Tag.includes('N|')),
  getCategorieEventoEuropeo: () => state.tipologie.filter((t) => t.Tipo === 'TipoCategoria' && t.Tag.includes('E|')),
  getTipiAssociazione: () => state.tipologie.filter((t) => t.Tipo === 'TipoAssociazione'),
  getTipiEvento: () => state.tipologie.filter((t) => t.Tipo === 'TipoGara'),
  getTipiSocieta: () => state.tipologie.filter((t) => t.Tipo === 'TipoSocieta'),
  getTipiTessera: () => state.tipologie.filter((t) => t.Tipo === 'TipoTessera'),
  getTipiAssicurazione: () => state.tipologie.filter((t) => t.Tipo === 'TipoAssicurazione'),
  getAnniSportivi: () => state.tipologie.filter((t) => t.Tipo === 'AnnoSportivo'),
  getAnniSportiviValidi: () => state.tipologie.filter((t) => t.Tipo === 'AnnoSportivo' && parseInt(t.Tag, 10) >= new Date().getFullYear()),
  getTitoliEventoFormativo: () => state.tipologie.filter((t) => t.Tipo === 'TipoEvento' && t.Tag.includes('F|')),
  getCategorieEventoIBO: () => state.tipologie.filter((t) => t.Tipo === 'TipoCategoria' && t.Tag === 'IBO'),
  getCategorieEventoSTO_EU: () => state.tipologie.filter((t) => t.Tipo === 'TipoCategoria' && t.Tag.includes('SE|')),
  getCategorieEventoSTO: () => state.tipologie.filter((t) => t.Tipo === 'TipoCategoria' && t.Tag.includes('S|')),
  getTitoliEventoDidattico: () => state.tipologie.filter((t) => t.Tipo === 'TipoEvento' && t.Tag.includes('D|')),
  getAnnoRinnovo: () => state.annoRinnovo,
  getParam: () => state.param,
};

const actions = {
  loadTipologie({ commit }) {
    axios
      .get(config.ROOT_API + '/api/shared/tipologie')
      .then(function (response) {
        commit('setTipologie', response.data);
      })
      .catch((err) => {
        //console.error(err);
      });
  },
  loadParam({ commit }, idItem) {
    axios
      .get(config.ROOT_API + '/api/shared/param/' + idItem)
      .then(function (response) {
        commit('setParam', response.data);
      })
      .catch((err) => {
        //console.error(err);
        commit('setParam', null);
      });
  },

  loadAnnoRinnovo({ commit }, idItem) {
    axios
      .get(config.ROOT_API + '/api/shared/param/ANNO_RINNOVO')
      .then(function (response) {
        commit('setAnnoRinnovo', response.data);
      })
      .catch((err) => {
        //console.error(err);
        commit('setAnnoRinnovo', null);
      });
  },
};

const mutations = {
  setTipologie(mdl, tipologie) {
    state.tipologie = tipologie;
  },
  setAnnoRinnovo(mdl, annoRinnovo) {
    state.annoRinnovo = annoRinnovo;
  },
  setParam(mdl, param) {
    state.param = param;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
